<template lang="html">
  <v-dialog
  v-model="showDialog"
  persistent
  max-width="350"
>
  <v-card>
    <v-card-title class="headline">Biztos törölni akarod?</v-card-title>

    <v-card-text>
      Az adatlap törlésével minden adat elvész, nem helyreállítható!
    </v-card-text>

    <v-card-actions>
      <div class="flex-grow-1"></div>

      <v-btn
        color="green--text darken-1"
        @click="deleteCancelled"
      >
        Vissza
      </v-btn>

      <v-btn
        color="error darken-1"
        text
        @click="deleteConfirmed"
      >
        Igen, törlöm!
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  props: ['showDialog'],
  data(){
    return{

    }
  },
  methods:{
    deleteCancelled(){
      this.$emit('deleteCancelled')
    },
    deleteConfirmed(){
      this.$emit('deleteConfirmed')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
